<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img
                v-if="gnrData?.branch?.company?.watermark && invoiceHeader"
                :src="fileServerUrl + orderInvoice?.branch?.company?.watermark"
                alt=""
                style="height: 400px!important"
            >
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <div>
                        <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                          <img
                              :src="`${getFileServerUrl}${gnrData?.branch?.company?.logo}`"
                              class="logo-img"
                              alt="Logo"
                              style="max-height: 80px;"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody v-if="gnrData">
                  <!-- GRN Details Section -->
                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px; margin-top: 10px;">

                        <div style="display: flex; justify-content: center;">
                          <h1 style="font-size: 16px; text-decoration: underline;">GRN Details</h1>
                        </div>

                        <div style="display: flex; justify-content: space-between; margin-bottom: 4px">
                          <div>
                            <div>
                              <strong>Supplier,</strong><br>
                              <strong>{{ gnrData.supplier?.supplier_name || 'N/A' }}</strong><br/>
                            </div>
                          </div>

                          <div>
                            <p><strong>GRN No:</strong> {{ gnrData.gnr_no }}</p>
                            <p><strong>GRN Date:</strong> {{ gnrData.gnr_date }}</p>
                            <p><strong>Code:</strong> {{ gnrData.code }}</p>
                            <p><strong>Status:</strong> {{ gnrData.status === 1 ? 'Posted' : 'Draft' }}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px;">
                        <div style="display: flex; justify-content: space-between; margin-bottom: 4px">
                          <div>
                            <p><strong>LC No:</strong> {{ gnrData.lc?.lc_no || 'N/A' }}</p>
                            <p><strong>LC Date:</strong> {{ gnrData.lc?.lc_open_date || 'N/A' }}</p>
                          </div>
                          <div>
                            <p><strong>Shipment No:</strong> {{ gnrData.shipment?.shipment_no || 'N/A' }}</p>
                            <p v-if="gnrData.remarks"><strong>Remarks:</strong> {{ gnrData.remarks }}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                        <tr>
                          <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                            Item Details
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Sn</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Code</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Product</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Expiry Date</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Received Qty</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Accepted Qty</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Rejected Qty</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Rate</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, idx) in gnrItems" :key="idx">
                            <td style="border:1px solid black; text-align:center;">{{ idx + 1 }}</td>
                            <td style="border:1px solid black; text-align:center;">{{ item.product?.code || '-' }}</td>
                            <td style="border:1px solid black;">{{ item.product?.name || '-' }}</td>
                            <td style="border:1px solid black; text-align:center;">{{ item.expiry_date || '-' }}</td>
                            <td style="border:1px solid black; text-align:right;">{{ formatNumber(item.received_qty) }}</td>
                            <td style="border:1px solid black; text-align:right;">{{ formatNumber(item.accepted_qty) }}</td>
                            <td style="border:1px solid black; text-align:right;">{{ formatNumber(item.rejected_qty) }}</td>
                            <td style="border:1px solid black; text-align:right;">{{ formatCurrency(item.rate) }}</td>
                            <td style="border:1px solid black; text-align:right;">{{ formatCurrency(item.amount) }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr style="background-color: #f0f0f0;">
                            <td colspan="3" style="border: 1px solid black; padding: 2px;"></td>
                            <td style="border: 1px solid black; padding: 2px; text-align:right; font-weight:bold;"><strong>TOTAL</strong></td>
                            <td style="border: 1px solid black; padding: 2px; text-align:right;">{{ formatNumber(totalReceivedQty) }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align:right;">{{ formatNumber(totalAcceptedQty) }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align:right;">{{ formatNumber(totalRejectedQty) }}</td>
                            <td style="border: 1px solid black; padding: 2px;"></td>
                            <td style="border: 1px solid black; padding: 2px; text-align:right;">{{ formatCurrency(totalGnrValue) }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Prepared & Issued By</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Authorized Signatory</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Received & Accepted By</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot v-if="invoiceHeader">
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; margin-bottom:10px; color: #343591;">
                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                  </svg>

                  <span>{{ getCurrentCompany?.address || '' }}</span>
                </p>

                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36.67-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                  </svg>

                  <strong>Phone: </strong>  {{ getCurrentCompany?.mobile || '' }}
                </p>
              </div>
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row v-if="gnrData" justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
          <v-btn
            v-if="gnrData?.approval_details"
            color="yellow"
            prepend-icon="mdi-clock-alert-outline"
            class="ml-2"
            @click="approvalActionSheet.open()"
          >
            Approval History
          </v-btn>
      </v-col>
    </v-row>

    <approval-action-sheet
      ref="approvalActionSheet"
      :approval-details="approvalDetails"
      :approval-status="gnrData?.approval_status"
      subject="GRN"
      @updated="handleApprovalUpdated"
    />

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import ApprovalActionSheet from "@/components/utils/approvalActionSheet.vue";
import {fileServerUrl} from "@/store/api.js";

const store = useStore();
const router = useRouter();
const route = useRoute();

const loading = ref(false);
const gnrData = ref(null);
const pagePadding = ref(0);
const invoiceHeader = ref(true);
const approvalActionSheet = ref(null);

const getCurrentCompany = computed(() => {
  return store.getters.getCurrentCompany || {};
});

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || "";
});

const approvalDetails = computed(() => gnrData.value?.approval_details || {});

const gnrItems = computed(() => {
  if (!gnrData.value) return [];
  const details = gnrData.value.gnr_details;
  return Array.isArray(details) ? details : [];
});

const totalReceivedQty = computed(() => {
  return gnrItems.value.reduce((sum, item) => sum + parseFloat(item.received_qty || 0), 0);
});

const totalAcceptedQty = computed(() => {
  return gnrItems.value.reduce((sum, item) => sum + parseFloat(item.accepted_qty || 0), 0);
});

const totalRejectedQty = computed(() => {
  return gnrItems.value.reduce((sum, item) => sum + parseFloat(item.rejected_qty || 0), 0);
});

const totalGnrValue = computed(() => {
  return gnrItems.value.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
});

const formatNumber = (num) => {
  if (!num && num !== 0) return "0.00";
  return Number(num).toFixed(2);
};

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return "0.00";
  return Number(amount).toFixed(2);
};

const loadGnrData = async () => {
  if (!route.params.id) {
    toast.error("GRN ID is required");
    router.push({ name: "lc-import-gnr-records" });
    return;
  }

  loading.value = true;
  try {
    await store.dispatch("getLcImportGnrById", route.params.id);
    const data = store.getters["getEditingLcImportGnr"];

    if (data) {
      if (!data.gnrDetails && data.gnr_details) {
        data.gnrDetails = data.gnr_details;
      }
      gnrData.value = data;
    } else {
      toast.error("GRN data not found");
      router.push({ name: "lc-import-gnr-records" });
    }
  } catch (error) {
    toast.error("Failed to load GRN data");
    router.push({ name: "lc-import-gnr-records" });
  } finally {
    loading.value = false;
  }
};

const handleApprovalUpdated = async () => {
  await loadGnrData();
};

const goBack = () => {
  router.push({ name: "lc-import-gnr-records" });
};

const print = (isPad) => {
  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>GRN Details</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }

        html, body {  
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }

        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }

        .header-table {
          padding: 0 32px;
        }

        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }

        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }

        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }

        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .details-table {
          padding: 0px 32px;
        }

        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }

        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }

        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }

        .company-name { 
          font-size: 12px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }

        .company-text { 
          font-size: 12px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }

        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }

        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }

        .watermark {
          position: fixed;
          transform: translate(143%, 170%);
          z-index: 0;
        }

        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 12px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }

        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .master-box-parent {
          border: none !important;
        }

        .master-box {
          margin: 16px 0;
        }

        .invoice-content {
          // page-break-inside: avoid;
        }

        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          orphans: 3;
          widows: 3;
        }
        
        tr {
          // page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }

        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }

        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
          padding: 0px 30px;
          justify-content:space-between;
        }

        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }

        .pa-6 { padding: 0 !important; }

        .order-table thead {
          display: table-header-group;
        }

        .order-table tbody {
          // page-break-inside: avoid;
        }

        div[style*="margin-top"], div[style*="padding"] {
          // page-break-inside: avoid;
        }

        .order-table tbody tr {
          // page-break-inside: avoid;
        }

        .signature-box {
          font-size: 12px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }

        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }

        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 12px;
        }

        .invoice-container {
          display: flex;
          flex-direction: column;
        }

        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }

        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 0px;
          width: 100%;    
        }

        @media print { 
          body {
            margin: 0;
            padding: 0;
          }

          .report-paper {
            margin: 0;
            padding: 0;
          }

          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
            
          .order-table {
            page-break-inside: auto;
          }

          .order-table tr {
            // page-break-inside: avoid;
            page-break-after: auto;
          }

          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;

  }, 500)
};

onMounted(() => {
  loadGnrData();
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 12px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 12px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  transform: translate(50%, 50%);
  z-index: 0; 
}
</style>

